export const resignManageRouter = [
  {
    path: "/staff-manage/resign-manage/list",
    name: "resign-manage-list",
    meta: { title: "离职管理" },
    component: () => import(/* webpackChunkName: "resign-manage-list" */ "@/views/staff-manage/resign-manage/list/index.vue"),
  },
  {
    path: "/staff-manage/resign-manage/add/:staffId?",
    name: 'resign-manage-add',
    meta: { title: '新增离职申请', comName: "StaffManageResignManageFormCreate"  },
    hidden: true,
    component: () => import(/* webpackChunkName: "resign-manage-add" */ "@/views/staff-manage/resign-manage/form-create/index.vue")
  },
  {
    path: "/staff-manage/resign-manage/edit/:id",
    name: 'resign-manage-edit',
    meta: { title: '编辑离职申请', comName: "StaffManageResignManageFormCreate" },
    hidden: true,
    component: () => import(/* webpackChunkName: "resign-manage-edit" */ "@/views/staff-manage/resign-manage/form-create/index.vue")
  },
  {
    path: "/staff-manage/resign-manage/detail/:id",
    name: 'resign-manage-detail',
    meta: { title: '离职申请详情' },
    hidden: true,
    component: () => import(/* webpackChunkName: "resign-manage-detail" */ "@/views/staff-manage/resign-manage/form-detail/index.vue")
  },
  {
    hidden: true,
    path: "/staff-manage/resign-manage/flowPrint/:id",
    name: "resign-flow-print",
    meta: { title: "打印详情" },
    component: () =>
      import(
        /* webpackChunkName: "project-profile" */ "@/views/staff-manage/resign-manage/flow-print/index.vue"
      ),
  },
]
